import React from 'react';
import '../error.css';

const ErrorPage = () => {
    return (
        <div className="over404">
            <div className="darkOverlay" />
            <header>
                <h1 className="glitch" data-text="404">404</h1>
            </header>
        </div>
    )
};

export default ErrorPage;
